import { queryOptions, useQuery } from "@tanstack/react-query";
import type { DesktopInfo } from "@goalhorns/shared";
import { ApiError, apiRequest } from "../../lib/api";
import { paths } from "../../lib/endpoints";

const DESKTOP_INFO_STALE_MS = 5 * 60_000;

/** The desktop app's info, or null when the server has no release (404 not_available). */
async function fetchDesktopInfo(): Promise<DesktopInfo | null> {
  try {
    return await apiRequest<DesktopInfo>(paths.desktopDownloadInfo);
  } catch (error) {
    if (error instanceof ApiError && error.status === 404) return null;
    throw error;
  }
}

export const desktopInfoQuery = queryOptions({
  queryKey: ["desktop-download-info"] as const,
  queryFn: fetchDesktopInfo,
  staleTime: DESKTOP_INFO_STALE_MS,
  retry: false,
});

/** Undefined while loading, null when the desktop app is not available, otherwise its info. */
export function useDesktopDownload() {
  return useQuery(desktopInfoQuery);
}
